import React from 'react';
import { motion } from 'framer-motion';

const CoreProblem = () => (
  <section className="py-20 border-t" style={{ background: '#0d0d0d', borderColor: '#1a1a1a' }}>
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4ade80' }}>The Problem</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-8" style={{ color: '#f1f1f1' }}>
          You already paid to make the phone ring.
        </h2>
        <div className="space-y-5">
          <p className="text-lg leading-relaxed" style={{ color: '#888' }}>
            Most operators spend money on ads, SEO, referrals, and reputation to drive inbound calls. When nobody answers, the customer calls the next company.
          </p>
          <p className="text-lg leading-relaxed" style={{ color: '#888' }}>
            Voicemail does not qualify the caller, capture urgency, or notify your team in a useful way. It is a dead end — and callers know it.
          </p>
        </div>
        <div className="mt-10 p-6 rounded-xl border-l-2" style={{ background: '#111', borderLeftColor: '#4ade80' }}>
          <p className="text-base font-medium" style={{ color: '#ccc' }}>
            The fix isn't hiring more staff. It's making sure every call that your team misses gets handled — cleanly, immediately, and without friction.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default CoreProblem;